import { AudioDevice } from '@hakimo-ui/hakimo/types';
import { Column as TableColumn, TableData } from '@hakimo-ui/hakimo/ui-table';
import { Button } from '@hakimo-ui/shared/ui-base';
import { PlusCircleIcon } from '@heroicons/react/24/outline';
import SPSToggle from '../update-sps/SPSToggle';
import AutomatedTalkdownGapChange from '../update-automated-talkdown/AutomatedTalkdownCooldown';
import AutomatedTalkdownToggle from '../update-automated-talkdown/AutomatedTalkdownToggle';

export const columns: TableColumn[] = [
  {
    id: 'clientAudioDeviceId',
    name: 'Client Audio Device ID',
    showAtBreakpoint: 'sm',
  },
  {
    id: 'url',
    name: 'URL',
  },
  {
    id: 'location',
    name: 'Location',
    showAtBreakpoint: 'sm',
  },
  {
    id: 'enabled',
    name: 'Auto Talkdown Enabled',
    showAtBreakpoint: 'sm',
  },
  {
    id: 'automatedTalkdownGapSec',
    name: 'Auto Talkdown Cooldown',
    showAtBreakpoint: 'sm',
  },
  {
    id: 'spsEnabled',
    name: 'SPS Enabled',
    showAtBreakpoint: 'sm',
  },
  {
    id: 'proxyUrl',
    name: 'Proxy URL',
    showAtBreakpoint: 'sm',
  },
  { id: 'action', name: '', showAtBreakpoint: 'sm' },
];

export function getTableData(
  items: AudioDevice[],
  canModifyAudioCamMap: boolean,
  onClickAddCam?: (item: AudioDevice) => void
): TableData {
  return {
    rows: items.map((audioDevice) => {
      return {
        id: String(audioDevice.id),
        cells: [
          {
            value: audioDevice.clientAudioDeviceId || '-',
          },
          {
            value: audioDevice.url,
          },
          {
            value: audioDevice.location.name,
          },
          {
            value: <AutomatedTalkdownToggle audioDevice={audioDevice} />,
          },
          {
            value: (
              <div className="flex items-center gap-2">
                <span>
                  {audioDevice.automatedTalkdownGapSec || '0'} seconds
                </span>
                <AutomatedTalkdownGapChange audioDevice={audioDevice} />
              </div>
            ),
          },
          {
            value: <SPSToggle audioDevice={audioDevice} />,
          },
          {
            value: audioDevice.isSPSEnabled ? audioDevice.proxyUrl || '' : '',
          },
          {
            value:
              canModifyAudioCamMap && onClickAddCam ? (
                <Button
                  variant="icon"
                  onClick={() => onClickAddCam(audioDevice)}
                >
                  <PlusCircleIcon className="h-5 w-5" />
                </Button>
              ) : null,
          },
        ],
      };
    }),
    columns,
  };
}
